export const fetchRecursive = async ({
  store,
  dispatch,
  controls,
  fetchPage,
  pageNumber = 1,
  pageSize = 100,
  accumulator = [],
}) => {
  const pageControls = {
    ...controls,
    page: {
      ...controls.page,
      number: pageNumber,
      size: pageSize,
    },
  };

  const response = await fetchPage(pageControls, store, dispatch);
  const responses = Array.isArray(response) ? response : [response];

  const primary = responses[0];

  if (!primary) {
    return accumulator;
  }

  const pageData = responses.flatMap((res) => res?.data ?? []);

  const combined = [...accumulator, ...pageData];

  const total = primary?.meta?.resources?.total ?? combined.length;
  const lastPage = Math.ceil(total / pageSize);

  const primaryData = primary?.data ?? [];

  if (pageNumber >= lastPage || primaryData.length === 0) {
    return combined;
  }

  return fetchRecursive({
    store,
    dispatch,
    controls,
    fetchPage,
    pageNumber: pageNumber + 1,
    pageSize,
    accumulator: combined,
  });
};
